const ResourceExplanation = () => {
    return (
        <>
            <div className="explanation-title">
                Resource
            </div>
            <div className="explanation-subtitle">
                Single or combined AWS resources
            </div>
            <br />

            <p>
                A <span style={{ fontStyle: "italic" }}>Resource</span> is an entity that is provisioned in your AWS account through Microtica.
            </p>
            <p>
                <span>
                    Resources can be created:
                </span>
                <ul>
                    <li>as standalone entities <span style={{ fontStyle: "italic" }}>(eg. S3 bucket, VPC)</span></li>
                    <li>as part of a compound component <span style={{ fontStyle: "italic" }}>(eg. Strapi)</span></li>
                </ul>
            </p>
            <p>
                Microtica allows you to manage the resources' version, configuration and monitor their deployment.
            </p>
        </>
    )
}

export default ResourceExplanation;